var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-carousel-item"},[_c('h6',[_vm._v(_vm._s(_vm.data.time))]),_c('p',{staticClass:"header"},[_vm._v(_vm._s(_vm.data.text))]),_c('b-link',{staticClass:"btn-readMore",attrs:{"href":_vm.data.link},on:{"click":function($event){return _vm.onclick()}}},[_vm._v("Read more")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }